import { render, staticRenderFns } from "./KeyWordSearchComponent.vue?vue&type=template&id=59f70eee&scoped=true&"
import script from "./KeyWordSearchComponent.vue?vue&type=script&lang=js&"
export * from "./KeyWordSearchComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59f70eee",
  null
  
)

export default component.exports